
































































import Vue from 'vue';
import { Component } from 'vue-property-decorator';

import { Inject } from '@/core/helpers/vue-inversify-decorator';
import {
    CONTRACTS,
    FetchServiceContract,
    WindowsServiceContract
} from '@/core/contracts';
import { Role } from '@/dto';
import { ContextsState } from '@/store';
import { localize } from '@/core/filters';
import RolePermissionsEdit from './RolePermissionsEdit.vue';
import DataFilters from './DataFilters.vue';

@Component({
    components: {
        RolePermissionsEdit,
        DataFilters
    }
})
export default class ContextSettingsRolesComponent extends Vue {
    public inLoading: boolean = false;
    public isBusy: boolean = false;
    public loadedRoles: Role[] = [];
    public newRoleName: string = '';
    public editedRole: Role | null = null;

    @Inject(CONTRACTS.FetchService)
    private _fetchService?: FetchServiceContract;
    @Inject(CONTRACTS.WindowsService)
    private _windowsService?: WindowsServiceContract;

    public async mounted() {
        await this.loadRoles();
    }

    public async createNewRole(): Promise<void> {
        this.isBusy = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            const newRole = await this._fetchService!.post<Role>(
                '/contexts/' + currentContextId + '/roles',
                this.newRoleName
            );
            this.loadedRoles.push(newRole);
            this.newRoleName = '';
        } finally {
            this.isBusy = false;
        }
    }

    public async deleteRole(roleId: number, roleName: string): Promise<void> {
        const agreeBtnId = 0;
        const title = localize('RoleDeleteMessage') as string;
        const selectedBtn = await this._windowsService!.showDialog(
            title.replace('{0}', roleName),
            [
                {
                    id: agreeBtnId,
                    caption: localize('TitleButtonDeleteRole')
                },
                {
                    id: 1,
                    caption: localize('CancelButtonText')
                }
            ]
        );
        if (selectedBtn === agreeBtnId) {
            this.isBusy = true;
            try {
                const currentContextId = ContextsState.currentContextId;
                await this._fetchService!.delete(
                    '/contexts/' + currentContextId + '/roles/' + roleId
                );
                this.loadedRoles = this.loadedRoles.filter(
                    f => f.id !== roleId
                );
            } finally {
                this.isBusy = false;
            }
        }
    }

    public async editRoleRights(roleId: number): Promise<void> {
        this.isBusy = true;
        try {
            const currentContextId = ContextsState.currentContextId;
            const roleWithPermissions = await this._fetchService!.get<Role>(
                '/contexts/' + currentContextId + '/roles/' + roleId
            );
            this.editedRole = roleWithPermissions;
        } finally {
            this.isBusy = false;
        }
    }

    private async loadRoles(): Promise<void> {
        if (this.loadedRoles.length === 0) {
            const currentContextId = ContextsState.currentContextId;
            const roles = await this._fetchService!.get<Array<Role>>(
                '/contexts/' + currentContextId + '/roles'
            );
            this.loadedRoles = roles;
        }
    }
}
